// RoadMapPage.jsx
import React from "react";
import './RoadMap.css';
import { Link } from "react-router-dom";

import PageBanner from "../../layouts/PageBanner";

const RoadMap = () => {
    return (
        <>
            <div className="page-content bg-white">
                <PageBanner pagetitle="Event Roadmap" maintitle="Home" />

                <section className="content-inner-2 bg-light section-wrapper5 section-pattren1" style={{paddingTop: "30px"}}>
                    <div className="our-history-wrapper section-space--ptb_100">
                        <div className="container">
                            <div className="row">
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", color: "#f4bd3a", fontSize: "xxx-large" }}><h1 style={{ color: "#f4bd3a", fontSize: "60px" }}>2024</h1>

                                </div>
                                <div className="col-lg-12">
                                    {/* section-title-wrap Start */}
                                    {/* <div className="section-title-wrap text-center section-space--mb_30">
                    <h3 className="heading mb-20">
                      We create dreams <span className="text-color-primary"> for the future.</span>{" "}
                      <br /> We realize them successfully.
                    </h3>
                    <p className="title-dec-text">
                      You know that you found your dream when you have a desire to achieve a goal,
                      have the gut to pursue it, have the courage to overcome any obstacles on your
                      path and feel blessed when finally realizing it. Dream on, keep up and make it
                      pay off.
                    </p>
                  </div> */}
                                    {/* section-title-wrap Start */}
                                </div>
                            </div>

                            <div className="timeline-area section-space--pt_60">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="ht-timeline style-01">
                                            <ul className="tm-timeline-list ht-animation-queue">
                                                <li className="line"></li>
                                                <li className="item animate">
                                                    <div className="dots">
                                                        <div className="middle-dot"></div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6 timeline-col left timeline-feature">
                                                            <div className="inner">
                                                                <div className="date-wrap">
                                                                    <h2 className="year" style={{ color: "#3da9ef", fontWeight: "bold" }}>JAN</h2>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 15px 0px 20px" }}>
                                                                    <h6 className="heading" style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>28</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                            Wellness Event - Yoga
                                                                        </div>
                                                                        நல்வாழ்வு நிகழ்ச்சி - யோகா பயிற்சி
                                                                    </h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="item animate">
                                                    <div className="dots">
                                                        <div className="middle-dot"></div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6 timeline-col left timeline-feature">
                                                            <div className="inner">
                                                                <div className="date-wrap">
                                                                    <h6 className="year" style={{ color: "#d8562c", fontWeight: "bold" }}>FEB</h6>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 0px 0px 0px" }}>
                                                                    <h6 className="heading"  style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>03</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        Thai Thiru Naal Vizha
                                                                        </div>தைத்திருநாள் கொண்டாங்கள் 2024</h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 timeline-col right timeline-info">
                                                            <div className="inner">
                                                                <div className="content-wrap">

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="item animate">
                                                    <div className="dots">
                                                        <div className="middle-dot"></div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6 timeline-col left timeline-feature">
                                                            <div className="inner">
                                                                <div className="date-wrap">
                                                                    <h2 className="year" style={{ color: "#3da9ef", fontWeight: "bold" }}>MAR</h2>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 15px 0px 20px" }}>
                                                                    <h6 className="heading"  style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>16</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        AnandhaYazh Musical Fest
                                                                        </div>ஆனந்தயாழ் இசைவிழா 2024</h6>
                                                                    </div>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 15px 0px 20px" }}>
                                                                    <h6 className="heading" style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>17</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        Wellness Event - Trekking
                                                                        </div>நல்வாழ்வு நிகழ்ச்சி - மலையேற்றம்</h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </li>
                                                <li className="item animate">
                                                    <div className="dots">
                                                        <div className="middle-dot"></div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6 timeline-col left timeline-feature">
                                                            <div className="inner">
                                                                <div className="date-wrap">
                                                                    <h6 className="year" style={{ color: "#d8562c", fontWeight: "bold" }}>APR</h6>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 0px 0px 0px" }}>
                                                                    <h6 className="heading" style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>14</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        Malligai Malar Release 1
                                                                        </div>முதல் காலாண்டு மல்லிகை மலர் வெளியீடு</h6>
                                                                    </div>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 0px 0px 0px" }}>
                                                                    <h6 className="heading" style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>20</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        Chitirai Thiruvizha
                                                                        </div>சித்திரைத்திருநாள் கொண்டாங்கள் 2024</h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 timeline-col right timeline-info">
                                                            <div className="inner">
                                                                <div className="content-wrap">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>

                                                <li className="item animate">
                                                    <div className="dots">
                                                        <div className="middle-dot"></div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6 timeline-col left timeline-feature">
                                                            <div className="inner">
                                                                <div className="date-wrap">
                                                                    <h2 className="year" style={{ color: "#3da9ef", fontWeight: "bold" }}>JUL</h2>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 15px 0px 20px" }}>
                                                                    <h6 className="heading" style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>04, 05, & 06</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        SATS - FETNA
                                                                        </div>பேரவை பெருவிழா 2024</h6>
                                                                    </div>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 15px 0px 20px" }}>
                                                                    <h6 className="heading" style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>25 & 28</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        Iyal, Isai, Nadaga Pattarai
                                                                        </div>இயல் இசை நாடகம் கூத்து - கோடைகால பயிற்சிப்பட்டறை-2024</h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </li>
                                                <li className="item animate">
                                                    <div className="dots">
                                                        <div className="middle-dot"></div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6 timeline-col left timeline-feature">
                                                            <div className="inner">
                                                                <div className="date-wrap">
                                                                    <h6 className="year" style={{ color: "#d8562c", fontWeight: "bold" }}>AUG</h6>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 0px 0px 0px" }}>
                                                                    <h6 className="heading" style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>03</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        Sports day - Kids
                                                                        </div>சிறுவர் ,சிறுமியர் விளையாட்டு விழா</h6>
                                                                    </div>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 0px 0px 0px" }}>
                                                                    <h6 className="heading" style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>15</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        Malligai Malar Release 2
                                                                        </div>இரண்டாம்  காலாண்டு மல்லிகை மலர் வெளியீடு</h6>
                                                                    </div>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 0px 0px 0px" }}>
                                                                    <h6 className="heading" style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>Aug - Sept</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        SATS - SAPL Cricket
                                                                        </div>சான் ஆண்டோனியோ பிரீமியர் லீக் கிரிக்கெட் தொடர் 2024</h6>
                                                                    </div>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 0px 0px 0px" }}>
                                                                    <h6 className="heading" style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>Aug - Sept</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        Sports Events - Adults
                                                                        </div>பெரியவர்கள் விளையாட்டு விழா</h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 timeline-col right timeline-info">
                                                            <div className="inner">
                                                                <div className="content-wrap">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>

                                                <li className="item animate">
                                                    <div className="dots">
                                                        <div className="middle-dot"></div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6 timeline-col left timeline-feature">
                                                            <div className="inner">
                                                                <div className="date-wrap">
                                                                    <h2 className="year" style={{ color: "#3da9ef", fontWeight: "bold" }}>SEP</h2>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 15px 0px 20px" }}>
                                                                    <h6 className="heading" style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>14</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        SATS Picnic
                                                                        </div>சா.ஆ.த சிறுசூழ்வரவு</h6>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>

                                                    </div>
                                                </li>
                                                <li className="item animate">
                                                    <div className="dots">
                                                        <div className="middle-dot"></div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6 timeline-col left timeline-feature">
                                                            <div className="inner">
                                                                <div className="date-wrap">
                                                                    <h6 className="year" style={{ color: "#d8562c", fontWeight: "bold" }}>OCT</h6>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 0px 0px 0px" }}>
                                                                    <h6 className="heading" style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>12</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        Wellness Event - Dental Camp
                                                                        </div>நல்வாழ்வு நிகழ்ச்சி - பல் மருத்துவ முகாம்</h6>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 timeline-col right timeline-info">
                                                            <div className="inner">
                                                                <div className="content-wrap">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>

                                                <li className="item animate">
                                                    <div className="dots">
                                                        <div className="middle-dot"></div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6 timeline-col left timeline-feature">
                                                            <div className="inner">
                                                                <div className="date-wrap">
                                                                    <h2 className="year" style={{ color: "#3da9ef", fontWeight: "bold" }}>NOV</h2>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 15px 0px 20px" }}>
                                                                    <h6 className="heading" style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>09</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        Deepavali Thirunaal
                                                                        </div>தீபஒளி திருநாள் கொண்டாங்கள் 2024</h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </li>
                                                <li className="item animate">
                                                    <div className="dots">
                                                        <div className="middle-dot"></div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6 timeline-col left timeline-feature">
                                                            <div className="inner">
                                                                <div className="date-wrap">
                                                                    <h6 className="year" style={{ color: "#d8562c", fontWeight: "bold" }}>DEC</h6>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 0px 0px 0px" }}>
                                                                    <h6 className="heading" style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>11</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        Malligai Malar Release 3
                                                                        </div>மூன்றாம் காலாண்டு மல்லிகை மலர் வெளியீடு</h6>
                                                                    </div>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 0px 0px 0px" }}>
                                                                    <h6 className="heading" style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>14</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        Muthamizh Vizha (Bharathiar Birthday)
                                                                        </div>பாரதியார் விழா</h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 timeline-col right timeline-info">
                                                            <div className="inner">
                                                                <div className="content-wrap">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", color: "#f4bd3a", fontSize: "xxx-large" }}>
                                    <h1 style={{ color: "#f4bd3a", fontSize: "60px" }}>2025</h1>
                                </div>
                                <div className="col-lg-12">

                                </div>
                            </div>

                            <div className="timeline-area section-space--pt_60">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="ht-timeline style-01">
                                            <ul className="tm-timeline-list ht-animation-queue">
                                                <li className="line"></li>
                                                <li className="item animate">
                                                    <div className="dots">
                                                        <div className="middle-dot"></div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6 timeline-col left timeline-feature">
                                                            <div className="inner">
                                                                <div className="date-wrap">
                                                                    <h2 className="year" style={{ color: "#3da9ef", fontWeight: "bold" }}>JAN</h2>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 15px 0px 20px" }}>
                                                                    <h6 className="heading" style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>18</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        Thai Thiru Naal Vizha
                                                                        </div>தைத்திருநாள் கொண்டாங்கள் 2025</h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="item animate">
                                                    <div className="dots">
                                                        <div className="middle-dot"></div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6 timeline-col left timeline-feature">
                                                            <div className="inner">
                                                                <div className="date-wrap">
                                                                    <h6 className="year" style={{ color: "#d8562c", fontWeight: "bold" }}>APR</h6>
                                                                </div>
                                                                <div className="content-body" style={{ margin: "0px 0px 0px 0px" }}>
                                                                    <h6 className="heading" style={{ color: "#b07c9c", fontSize: "18px", marginBottom: "2px" }}>19</h6>

                                                                    <div className="text"><h6 style={{ fontSize: "13px" }}>
                                                                        <div style={{ marginBottom: "2px" }}>
                                                                        AnandhaYazh Musical Fest
                                                                        </div>ஆனந்தயாழ் இசைவிழா 2025</h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 timeline-col right timeline-info">
                                                            <div className="inner">
                                                                <div className="content-wrap">

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* ... (existing code for background shapes) */}
                </section>
            </div>
        </>
    );
};

export default RoadMap;


// import React from 'react';
// import './RoadMap.css'; // Import your CSS file

// function Roadmap() {
//     const roadmapData = [
//         { title: 'Phase 1', milestones: [] }, // Close the array with ']'
//         { title: 'Phase 2', milestones: [] }, // Close the array with ']'
//         // ... add more phases
//     ];

//   return (
//     <div className="roadmap-container">
//       {roadmapData.map((phase, index) => (
//         <div key={index} className="roadmap-section">
//           <h2 className="roadmap-section-title">{phase.title}</h2>
//           <ul className="roadmap-milestones">
//             {phase.milestones.map((milestone, index) => (
//               <li key={index} className="roadmap-milestone">
//                 {milestone.description}
//                 {/* Add optional visual elements (icons, progress bars, etc.) */}
//               </li>
//             ))}
//           </ul>
//         </div>
//       ))}
//     </div>
//   );
// }

// export default Roadmap;
